import * as React from 'react'
import { LinkProps } from '@amzn/dvui/dist/Link'
import { IconType } from '@amzn/dvui/dist/Icon'
import { PrimeButton } from '@amzn/dvui/dist/Button'
import { ModalTrigger } from '@shared/utils/modalTrigger/ModalTrigger'
import { TextLocalizer } from '../localizer/localizer'
import * as st from './feedbackForm.module.scss'
import { Logger, constructQueryString } from '@utils'
import { CloseableDropList } from '../../utils/closeableDropList'
import { popupWindowParams } from '@shared/utils/utils'
import { DPRecordRefTag } from '../../utils/DPRecordRefTag'

const TARGET_WINDOW_WIDTH = 500
const TARGET_WINDOW_HEIGHT = 540

export interface FormParams {
  ASIN: string,
  deviceName: string,
  deviceTypeId: string,
  encryptedCustomerId: string,
  recordTerritory: string,
  currentTerritory: string,
  language: string,
  marketplace: string,
  playerSource: string,
  returnUrl: string,
  sourceUrl: string,
  sessionId: string,
}

export interface FeedbackFormModalContentProps {
  dropListId: string,
  dropListLinks: LinkProps[],
  logger: Logger,
  formUrl: string,
  formParams: FormParams,
  formOnSubmitFn?: () => void,
}

export const FeedbackFormModalContent = ({
  dropListId,
  dropListLinks,
  logger,
  formUrl,
  formParams,
  formOnSubmitFn,
}: FeedbackFormModalContentProps) => {
  const submit = () => {
    formOnSubmitFn && formOnSubmitFn()
    window.open(
      formUrl + constructQueryString(logger, formParams),
      '_blank',
      popupWindowParams(TARGET_WINDOW_WIDTH, TARGET_WINDOW_HEIGHT)
    )
  }

  return (
    <>
      <h4 className={`${st.feedbackQuestion}`}>
        <TextLocalizer stringID='DV_WEB_FEEDBACK_select_related_device'/>
      </h4>
      <div className={`${st.feedbackFormDropList}`} data-automation-id="feedback-drop-list" data-testid="feedback-drop-list">
        <CloseableDropList links={dropListLinks} customDropListID={dropListId}/>
      </div>
      <PrimeButton useIcon={IconType.EXTERNAL} onClick={submit} className={`${st.feedbackFormContinue}`}
                   data-automation-id="feedback-submit-button" data-testid="feedback-submit-button">
        <TextLocalizer stringID='DV_WEB_FEEDBACK_submit_button'/>
      </PrimeButton>
    </>
  )
}

interface FeedbackFormModalProps {
  isOpen: boolean,
  link: React.ReactNode,
  linkOnClickFn: () => void,
  onCloseFn: () => void,
  header: React.ReactNode,
  children: React.ReactNode,
}

export const FeedbackFormModal = ({
  isOpen = false,
  link,
  linkOnClickFn,
  onCloseFn,
  header,
  children
}: FeedbackFormModalProps) => (
  <ModalTrigger
    size='xs'
    isOpen={isOpen}
    toggle={() => (
      <DPRecordRefTag refTag={"atv_dp_fb_open"}>
        <button data-automation-id="feedback-button" data-testid="feedback-button" className={`${st.feedbackLink}`}
                onClick={linkOnClickFn}>
          {link}
        </button>
      </DPRecordRefTag>
    )}
    onClose={onCloseFn}
    modalHeader={<strong>{header}</strong>}
    modalContent={children as React.ReactChild}
    className={`${st.feedbackFormModal}`}
  />
)
